import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ShapeInteface } from "@WhiteCap/Utils/ValueAndTotalCalculate";
import { Draft } from "immer";

export interface ConcreteCalculationFormState {
	isLoading: boolean;
	shapes: ShapeInteface[],
}

const initialState: ConcreteCalculationFormState = {
	isLoading: false,
	shapes:[]
};

const ConcreteCalculatorReducer = {
	"Custom/ConcreteQuote/BeginLoadCalculation": (draft: Draft<ConcreteCalculationFormState>) => {
		draft.isLoading = true;
	},
	"Custom/ConcreteQuote/CompleteLoadCalculation": (
		draft: Draft<ConcreteCalculationFormState>,

	) => {
		draft.isLoading = false;
	},
	"Custom/ConcreteQuote/LoadShapeCalcuation": (
		draft: Draft<ConcreteCalculationFormState>,
		action:{
            shapes: ShapeInteface[]
        }
	) => {
		draft.shapes = action.shapes;
	},

};

export default createTypedReducerWithImmer(initialState, ConcreteCalculatorReducer);
